import React, { ReactNode, FC } from "react";
import { motion } from "motion/react";

import { Box, Button, Stack, Typography } from "@components/base";

interface StatusCardProps {
  icon: ReactNode;
  color: string;
  shadowColor: string;
  title: string;
  buttonLabel?: string;
  onButtonClick?: () => void;
}

const StatusCard: FC<StatusCardProps> = ({
  icon,
  color,
  shadowColor,
  title,
  buttonLabel,
  onButtonClick,
}) => (
  <motion.div
    initial={{ opacity: 0, scale: 0.96 }}
    animate={{ opacity: 1, scale: 1 }}
    transition={{ duration: 0.35, ease: "easeOut" }}
  >
    <Stack alignItems="center" spacing={2} py={4}>
      <motion.div
        initial={{ scale: 0, rotate: -30 }}
        animate={{ scale: 1, rotate: 0 }}
        transition={{ type: "spring", stiffness: 260, damping: 20 }}
      >
        <Box
          sx={{
            color,
            fontSize: 64,
            filter: `drop-shadow(0 0 8px ${shadowColor})`,
          }}
        >
          {icon}
        </Box>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.15, duration: 0.3 }}
      >
         <Typography variant="subtitle1" textAlign="center">
          {title}
        </Typography>
      </motion.div>

      {buttonLabel && onButtonClick && (
        <motion.div
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.25, duration: 0.3 }}
          style={{ alignSelf: "stretch" }}
        >
          <Button onClick={onButtonClick} size="medium" variant="contained" fullWidth>
            {buttonLabel}
          </Button>
        </motion.div>
      )}
    </Stack>
  </motion.div>
);

export default StatusCard;
